import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { IntegrationDetailPage } from '@/pages/integrations/detail/IntegrationDetailPage'
import { parseServiceIntegrationSearch } from '@/pages/integrations/detail/integration-detail-search'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug_/services/$serviceId'
)({
  validateSearch: parseServiceIntegrationSearch,
  component: IntegrationServiceDetailRoute,
  staticData: {
    pageHeader: { title: 'Service', customHeader: true, pad: false },
  },
})

function IntegrationServiceDetailRoute() {
  const { workspaceId, auditCycleId, providerSlug, serviceId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <IntegrationDetailPage
      workspaceId={workspaceId}
      auditCycleId={auditCycleId}
      providerSlug={providerSlug}
      serviceId={serviceId}
      search={search}
      onSearchChange={(next) => navigate({ search: next })}
    />
  )
}
